/* istanbul ignore file */

import { Module } from 'vuex';
import { AppState } from '..';
import { Restaurant } from '@/models';
import { prefixValues } from '@/helpers/util';

export interface RestaurantModuleState {
  selectedRestaurant: Restaurant | null;
  restaurantSearchResults: Restaurant[];
  restaurantFavorites: Restaurant[];

  // Customer's most recent restaurant ordered from
  mostRecentRestaurant: Restaurant | null;

  // This is used only for group order participant flow so the participant's meal builder will using the restaurant
  // associated with the group order
  groupOrderRestaurant: Restaurant | null;

  // For group order participant flow, we store the selectedRestaurant so it can be reset afterwards
  preGroupOrderFlowRestaurant: Restaurant | null;
}

const modulePrefix = 'restaurant/';
const MUTATION_NAMES = {
  SET_SELECTED_RESTAURANT: 'setSelectedRestaurant',
  SET_RESTAURANT_SEARCH_RESULTS: 'setRestaurantSearchResults',
  SET_RESTAURANT_FAVORITES: 'setRestaurantFavorites',
  SET_MOST_RECENT_RESTAURANT: 'setRecentRestaurant',
  SET_GROUP_ORDER_RESTAURANT: 'setGroupOrderRestaurant',
  SET_PRE_GROUP_ORDER_FLOW_RESTAURANT: 'setPreGroupOrderFlowRestaurant',
};

const GETTER_NAMES = {
  GET_SELECTED_RESTAURANT_ID: 'getSelectedRestaurantId',
};

export const MUTATIONS = prefixValues(MUTATION_NAMES, modulePrefix);
export const GETTERS = prefixValues(GETTER_NAMES, modulePrefix);

export function makeRestaurantModule(): Module<RestaurantModuleState, AppState> {
  return {
    namespaced: true,
    state: {
      selectedRestaurant: null,
      restaurantSearchResults: [],
      restaurantFavorites: [],
      mostRecentRestaurant: null,
      preGroupOrderFlowRestaurant: null,
      groupOrderRestaurant: null,
    },
    mutations: {
      [MUTATION_NAMES.SET_SELECTED_RESTAURANT]: (state, restaurantInfo: Restaurant) => {
        state.selectedRestaurant = restaurantInfo;
      },
      [MUTATION_NAMES.SET_RESTAURANT_SEARCH_RESULTS]: (state, restaurantSearchResults: Restaurant[]) => {
        state.restaurantSearchResults = restaurantSearchResults;
      },
      [MUTATION_NAMES.SET_RESTAURANT_FAVORITES]: (state, restaurantFavorites: Restaurant[]) => {
        state.restaurantFavorites = restaurantFavorites;
      },
      [MUTATION_NAMES.SET_MOST_RECENT_RESTAURANT]: (state, mostRecentRestaurant: Restaurant) => {
        state.mostRecentRestaurant = mostRecentRestaurant;
      },
      [MUTATION_NAMES.SET_GROUP_ORDER_RESTAURANT]: (state, restaurant: Restaurant) => {
        state.groupOrderRestaurant = restaurant;
      },
      [MUTATION_NAMES.SET_PRE_GROUP_ORDER_FLOW_RESTAURANT]: (state, restaurant: Restaurant) => {
        state.preGroupOrderFlowRestaurant = restaurant;
      },
    },
    getters: {
      [GETTER_NAMES.GET_SELECTED_RESTAURANT_ID]: state => (state.selectedRestaurant ? state.selectedRestaurant.restaurantNumber : null),
    },
  };
}
